import { palette } from "lib/miolo";
import IconCard, { CardDescription, CardValue } from "components/company/v2/cards/IconCard";
import { getYear } from "date-fns";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import parseDateYmd from "lib/utils/parseDateYmd";
import numeral from "numeral";

interface IEmployeesCountCardProps {
  issuer: IBrazilianCompanyIssuerTopLevelFragment;
}

export default function EmployeesCountCard({ issuer }: IEmployeesCountCardProps) {
  if (!issuer.employeeNumbers) {
    return null;
  }

  const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 21 21">
      <g transform="translate(-27 -34)" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g stroke="currentColor" strokeWidth={2} transform="translate(28.2 34.75)">
          <ellipse cx={9.229} cy={4.333} rx={4.411} ry={4.333} />
          <path d="M2.237 19.333h13.985c1.55 0 2.743-1.309 2.02-2.655-1.065-1.98-3.492-4.345-9.013-4.345-5.52 0-7.948 2.364-9.012 4.345-.724 1.346.47 2.655 2.02 2.655z" />
        </g>
      </g>
    </svg>
  );

  return (
    <div>
      <IconCard primaryColor={palette.fiord} secondaryColor={palette.catskillWhite} icon={icon}>
        <CardValue>{numeral(issuer.employeeNumbers.totalOfEmployees).format("0,0").replace(",", ".")}</CardValue>
        <CardDescription>N° de Empregados • {getYear(parseDateYmd(issuer.employeeNumbers.asOfDate))}</CardDescription>
      </IconCard>
    </div>
  );
}
